<template>
    <div id="compare-view-modal" class="modal-new hidden">
        <svg class="btn-close-modal" @click="close" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24"
             width="24">
            <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
        </svg>

        <div class="modal-title-container">
            <span class="title">
                Compare View
            </span>

            <div class="d-flex justify-space-between mt-10 mb-5">
                <v-slider
                    v-model="zoomLevel"
                    @input="updateZoomLevelClass"
                    :min="2"
                    :max="5"
                    :step="1"
                    style="width: 20%; flex: initial;"
                    dark
                    dense
                    color="var(--primary)"
                    append-icon="mdi-magnify-plus-outline"
                    prepend-icon="mdi-magnify-minus-outline"
                />

<!--                <span @click="downloadAllLuts"-->
<!--                      class="btn-download-all"-->
<!--                      :class="{ disabled: !canUseColorGradingTools }"-->
<!--                      v-if="compareView.length > 0 && compareView[0].loaded && compareView[0].type !== 'image'"-->
<!--                >-->
<!--                    <i class="material-icons">save_alt</i>Download All LUTs-->
<!--                </span>-->
            </div>
        </div>

        <div class="modal-content-container scrollable-con" :class="zoomLevelClass">
            <CompareViewItem v-for="asset in compareView" :key="asset.id" :asset="asset" />
        </div>

    </div>
</template>

<script>
import CanMixin from '@/mixins/CanMixin';
import { mapState } from 'vuex';
import CompareViewItem from '@/components/app/compare-view/CompareViewItem.vue';
import FilenameMixin from "@/mixins/Filename";

export default {
    mixins: [CanMixin, FilenameMixin],
    components: {CompareViewItem},
    data() {
        return {
            zoomLevel: 3,
            zoomLevelClass: 'grid-col-4'
        }
    },

    computed: {
        ...mapState('UI', ['compareView'])
    },

    methods: {
        close() {
            window.UI.hideModal(undefined, true);
        },

        updateZoomLevelClass() {
            if (this.zoomLevel == 2) this.zoomLevelClass = 'grid-col-5'
            if (this.zoomLevel == 3) this.zoomLevelClass = 'grid-col-4'
            if (this.zoomLevel == 4) this.zoomLevelClass = 'grid-col-3'
            if (this.zoomLevel == 5) this.zoomLevelClass = 'grid-col-2'
        },

        async downloadAllLuts() {
            if (lutify.isCurrentPlanFree()) {
                UI.showSecondLevelModal(UI.modals.notAvailableInFree.el);
                return;
            }

            const selectedFiles = this.compareView.filter(asset => asset.loaded);

            let assetsStoreData = [];
            for await (const file of selectedFiles) {
                if (file.type == "candidate") assetsStoreData.push(await window.lutify.fetchCandidate(file));
                else if (file.type == "match") assetsStoreData.push(await window.lutify.fetchMatch(file));
            }

            await this.$store.dispatch("Projects/setAction", {
                type: selectedFiles[0].type,
                action: "export-lut-from-asset",
                data: assetsStoreData,
            });

            this.$store.dispatch('UI/setRightColumn', 'download-lut');
            window.UI.hideModal();
        },
    }
};
</script>

<style lang="scss" scoped>
.modal-new {
  width: 95vw;
  height: 95vh;
}

.btn-download-all {
  display: flex;
  align-items: center;
  font-size: 1rem;
  cursor: pointer;
  border: 2px solid var(--font-default-color);
  border-radius: 15px;
  padding: 7px 15px;
  gap: 7px;

  > i {
    font-size: 18px;
  }
}

::v-deep .v-input__slider {
  .v-messages {
    display: none;
  }

  .v-slider__thumb {
    cursor: pointer;

    &:before {
      display: none;
    }
  }
}

.modal-content-container {
  width: 100%;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-gap: 1rem;

  &.grid-col-2 {
    grid-template-columns: repeat(2, 1fr)
  }

  &.grid-col-3 {
    grid-template-columns: repeat(3, 1fr)
  }

  &.grid-col-4 {
    grid-template-columns: repeat(4, 1fr)
  }

  &.grid-col-5 {
    grid-template-columns: repeat(5, 1fr)
  }
}
</style>
